import type { AppState, AppAction } from '../appReducerTypes';

export function journalReducer(state: AppState, action: AppAction): AppState {
  switch (action.type) {
    case 'SET_JOURNAL_NOTES':
      return { ...state, journalNotes: action.payload };
    case 'ADD_JOURNAL_NOTE':
      return {
        ...state,
        journalNotes: [action.payload, ...state.journalNotes],
      };
    case 'DELETE_JOURNAL_NOTE':
      return {
        ...state,
        journalNotes: state.journalNotes.filter((note) => note.id !== action.payload),
      };
    case 'SET_SHOW_JOURNAL_NOTES':
      return { ...state, showJournalNotesInEHR: action.payload };
    default:
      return state;
  }
}
